import { createAction, props } from '@ngrx/store';
import { Globals} from "../../Globals";

export const loggedInUserInfo = createAction(
    '[AppContext] User Info',
    props<{item:Globals}>()
);

export const AppContextActionTypes: string[] = [
    loggedInUserInfo.type,
];